import { render, staticRenderFns } from "./upload-image-message.vue?vue&type=template&id=23688ffe&scoped=true&"
import script from "./upload-image-message.vue?vue&type=script&lang=js&"
export * from "./upload-image-message.vue?vue&type=script&lang=js&"
import style0 from "./upload-image-message.vue?vue&type=style&index=0&id=23688ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23688ffe",
  null
  
)

export default component.exports